const style = {
  root: {
    marginBottom: '20px',
  },
} as const;

export default style;
